import { HttpClient } from '@angular/common/http';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import { messagefromComponent } from '../../class/appinterface';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { Utenteservice } from '../../services/utente.service';
import { NicaInfoAnagraficaAziendaComponent } from '../anagrafiche/nica-info-anagrafica-azienda/nica-info-anagrafica-azienda.component';
import { NicaFormComponent } from '../nica-form/nica-form.component';
import { alert } from 'devextreme/ui/dialog';
import { OverlaySideFormComponent } from '../shared/overlay-side-form/overlay-side-form.component';
import notify from 'devextreme/ui/notify';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NicaMenuService } from '../../services/nica-menu.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMaster } from '../nica-master-component/nica-master.component';
import { NewNicaFormComponent } from '../nica-form/new-nica-form.component';




@Component({
  providers: [NicaInfoAnagraficaAziendaComponent, OverlaySideFormComponent],
  selector: 'app-nica-gestione-azienda',
  templateUrl: './nica-gestione-azienda.component.html',
  styleUrls: ['./nica-gestione-azienda.component.css', '../../layout/header/header.component.scss', '../nica-form/nica-form.component.css', '../../components/shared/nica-chart-maker/nica-chart-maker.component.css']

})
export class NicaGestioneAziendaComponent extends NicaMaster implements OnInit, AfterViewInit, AfterViewChecked {

  @Input() dati: any; //Per quando i dati dovranno arrivare dalla griglia (OverlaySidePanelService)
  @Output('onToolbarButtonClick') onToolbarButtonClick: EventEmitter<any> = new EventEmitter<any>();

  infoAnagraficaMessage: any;

  @ViewChild(NewNicaFormComponent, { static: false }) gestioneAzienda: NewNicaFormComponent;
  //@ViewChild(NicaInfoAnagraficaAziendaComponent, { static: false}) infoAnagraficaAzienda: NicaInfoAnagraficaAziendaComponent;



  formDataJSON: any;

  buttonCustom = [
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Salva',
      icon: "glyphicon mdi mdi-content-save-outline",
      event: 'confermaAzienda',
      name: 'confermaAzienda',
      class: '',
      options:
      {
        stylingMode: "text",
        text: 'Salva',
        //hint: "Genera a video il grafico con i filtri applicati",
        icon: "glyphicon mdi mdi-content-save-outline",

        visible: true,
        onClick: async ($event) => {
          await this.gestisciEventoPulsante('confermaAzienda');
        }
      }
    },
    {

      location: "after",
      widget: "dxButton",
      locateInMenu: "never",
      stylingMode: 'text',
      options: {
        stylingMode: "text",
        text: 'Chiudi',
        //hint: "Genera a video il grafico con i filtri applicati",
        icon: "mdi mdi-close",
        onClick: () => {
          const cUrl = this.router.url.split('?')[0];
          const navigationParams = {
            id: this.currentTabId,
            masterKey: 'id',
            api: this.apiset,
            service: this.SubjectCall,
            filter: this.params.filter,
            data: this.params.data,
            currentTabId: this.currentTabId,
            currentTabName: this.currentTabName,
            componentName: this.currentTabName,
            close: true

          }
          this.router.navigate(['/'], {
            skipLocationChange: false,
            replaceUrl: true
          }).then(() => {
            let navigationExtras: NavigationExtras = {
              queryParams: navigationParams,
              skipLocationChange: false,
              replaceUrl: true
            };
            this.router.navigate([cUrl], navigationExtras);
          });
        }

      }


    },
  ];

  logoBase64?: string = "";

  dimensioniOriginali?: string;
  utenteService: Utenteservice;

  constructor(public componentService: ComponentService, private http: HttpClient, public utenteServicee: Utenteservice, private apiservice: Apiservice, private cdRef: ChangeDetectorRef, public _overlaySidePanelService: OverlaySideFormService, public router: Router,
    public menuService: NicaMenuService, public userComponentService: ComponentService, public anagraficaService: AnagraficaService, public templateService: FormsTemplateService, public activatedroute: ActivatedRoute
  ) {
    super(componentService, templateService, _overlaySidePanelService);

    this.utenteService = utenteServicee;
  }


  ngAfterViewInit(): void {
    /*
    this.dimensioniOriginali = `Larghezza: ${(document.getElementById('logoAzienda') as HTMLImageElement).naturalWidth}px. - Altezza: ${(document.getElementById('logoAzienda') as HTMLImageElement).naturalHeight}px.`;
    */
  }

  ngAfterViewChecked(): void {




    //this.dimensioniOriginali = this.dimensioniOriginali = `Larghezza: ${(document.getElementById('logoAzienda') as HTMLImageElement).naturalWidth}px. - Altezza: ${(document.getElementById('logoAzienda') as HTMLImageElement).naturalHeight}px.`; 
    this.cdRef.detectChanges();


  }



  async ngOnInit(): Promise<void> {

    let aziendaSelezionata: any;



    switch (this.utenteService.DammiTipoUtente()) {

      case 1:
      case 2: {

        this.buttonCustom.push({
          location: "after",
          stylingMode: "text",
          widget: "dxButton",
          locateInMenu: "never",
          text: 'Annulla',
          icon: "glyphicon glyphicon icon-annulla-form",
          event: 'annullaAzienda',
          name: 'annullaAzienda',
          class: '',
          options: undefined
        },
        );

        //Quindi sto creando l'azienda
        if (!this.dati) {

          this.logoBase64 = undefined;

          return;
        } else {

          aziendaSelezionata = this.dati;

        }


      } break;

      case 3: {  //Sono un admin, sto cambiando i dati della mia azienda selezionata

        /*
       aziendaSelezionata = (this.utenteService.InfoUtenteConnesso.aziende as any[]).find(
          (azienda)=>{
            return azienda.id == this.utenteService.InfoUtenteConnesso.aziendaSelected
          }
        );
        */

        aziendaSelezionata = await this.http.get<any>(environment.BASE_API_URL.concat(`Azienda/${this.utenteService.InfoUtenteConnesso.aziendaSelected}`)).toPromise();


      } break;


    }




    //console.log(aziendaSelezionata);

    setTimeout(
      () => {
        this.gestioneAzienda.dataSet['codiceFiscaleAzienda'] = aziendaSelezionata['codiceFiscaleAzienda']
        this.gestioneAzienda.dataSet['descrizione'] = aziendaSelezionata['descrizione']
        this.gestioneAzienda.dataSet['comune'] = aziendaSelezionata['comune']
        this.gestioneAzienda.dataSet['cap'] = aziendaSelezionata['cap']
        this.gestioneAzienda.dataSet['indirizzo'] = aziendaSelezionata['indirizzo']
        this.gestioneAzienda.dataSet['civico'] = aziendaSelezionata['civico']
        this.gestioneAzienda.dataSet['frazione'] = aziendaSelezionata['frazione']
        this.gestioneAzienda.dataSet['siglaProvincia'] = aziendaSelezionata['siglaProvincia']
        this.gestioneAzienda.dataSet['isAttiva'] = aziendaSelezionata['isAttiva']
        this.gestioneAzienda.dataSet['annoInstallazione'] = aziendaSelezionata['annoInstallazione'].toString()
        this.gestioneAzienda.dataSet['istatComune'] = aziendaSelezionata['istatComune']
        this.gestioneAzienda.dataSet['pIvaAzienda'] = aziendaSelezionata['pIvaAzienda']
        this.gestioneAzienda.dataSet['pec'] = aziendaSelezionata['pec']

        this.logoBase64 = aziendaSelezionata.logoAzienda ? aziendaSelezionata.logoAzienda : undefined
      }, 500
    )

    setTimeout(
      () => {
        this.dimensioniOriginali = `Larghezza: ${(document.getElementById('logoAzienda').children.item(0) as HTMLImageElement).naturalWidth}px. - Altezza: ${(document.getElementById('logoAzienda').children.item(0) as HTMLImageElement).naturalHeight}px.`;
      }, 1000
    )




    if (this.dati != undefined) {

      this.setGlobalVariable(this.dati);




    } else {
      //console.log('url',this.router.url)
      this.activatedroute.queryParams
        .subscribe(params => {
          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName


          this.showToolBar = false//Per ora ...

          this.setGlobalVariableFromParams(params);




        });

    }


  }
  emettiButtonToolbarClick(event) {
    if (event === 15) {
      this.gestisciEventoPulsante('confermaAzienda')
    }
    if (this.utenteService.InfoUtenteConnesso.aziendaSelected && this.utenteService.DammiTipoUtente() > 2) {
      if (event === 'close') {
        const cUrl = this.router.url.split('?')[0];
        const navigationParams = {
          id: this.currentTabId,
          masterKey: 'id',
          api: this.apiset,
          service: this.SubjectCall,
          filter: this.params.filter,
          data: this.params.data,
          currentTabId: this.currentTabId,
          currentTabName: this.currentTabName,
          componentName: this.currentTabName,
          close: true

        }
        this.router.navigate(['/'], {
          skipLocationChange: false,
          replaceUrl: true
        }).then(() => {
          let navigationExtras: NavigationExtras = {
            queryParams: navigationParams,
            skipLocationChange: false,
            replaceUrl: true
          };
          this.router.navigate([cUrl], navigationExtras);
        });
      }
    } else {
      if (event === 'close') {
        this.componentService.destroyCurrentOpenPopUp('NicaGestioneAziendaComponent')
      }
    }
  }


  async gestisciEventoPulsante(e) {

    if (e.name) {


      if (e.name.toLowerCase() == 'codicefiscale' || e.name.toLowerCase() == 'infopiva') {

        let current = '';

        console.warn(e);

        if (e.name.toLowerCase() == 'codicefiscale') {
          current = e.data['codiceFiscaleAzienda'].trim();
        }

        if (e.name.toLowerCase() == 'infopiva') {
          current = e.data['pIvaAzienda'].trim();
        }

        if (!current) {
          alert("Inserire un codice fiscale o P.Iva", 'Attenzione!');
          return
        }
        let dataTosend = [{
          dati: current
        }]

        this.openComponentInPopUP('NicaInfoAnagraficaAziendaComponent', dataTosend, undefined, '800', 'Dati Impresa', false, false);
        this.userComponentService.outputComponent.subscribe(currentOutput => {

          if (currentOutput.eventName == 'incollaDatiImpresa' && currentOutput.componentName == 'NicaInfoAnagraficaAziendaComponent' && NicaInfoAnagraficaAziendaComponent.isMsgPartitaIVA(currentOutput)) {

            //console.warn('CORRENTE',currentOutput)

            //if (ress['soloDati']) {

            //let desc = "?$filter=((contains(tolower(descrizione)," + "'" + ress['localita'].toLowerCase() + "')))"
            const localita = currentOutput['localita'].replace(/'/g, "''");
            let desc = `?$filter=descrizione eq '${localita}'`;
            this.anagraficaService.getElenco('Comune', '', desc).then(ree => {

              if (ree['items']) {
                this.gestioneAzienda.formRefreshInputData('istatComune', ree['items'][0]['id']);
                this.gestioneAzienda.formRefreshInputData('comune', ree['items'][0]['descrizione']);
                this.gestioneAzienda.formRefreshInputData('stato', 'IT');
                this.gestioneAzienda.formRefreshInputData('cap', ree['items'][0]['cap']);
                this.gestioneAzienda.formRefreshInputData('stato', 'IT');
              }

            })




            this.gestioneAzienda.formRefreshInputData('ragioneSociale', currentOutput['ragione_Sociale']);
            this.gestioneAzienda.formRefreshInputData('descrizione', currentOutput['ragione_Sociale']);
            this.gestioneAzienda.formRefreshInputData('isoFiscale', 'IT');
            this.gestioneAzienda.formRefreshInputData('siglaProvincia', currentOutput['prov']);
            this.gestioneAzienda.formRefreshInputData('indirizzo', currentOutput['indirizzo']);
            this.gestioneAzienda.formRefreshInputData('comune', currentOutput['localita']);
            this.gestioneAzienda.formRefreshInputData('pIvaAzienda', currentOutput['tax']);
            this.gestioneAzienda.formRefreshInputData('codiceFiscaleAzienda', currentOutput['vat']);
            this.gestioneAzienda.formRefreshInputData('civico', currentOutput['civico']);
            this.gestioneAzienda.formRefreshInputData('stato', 'IT');


            if (!currentOutput['escludiPec']) {
              this.gestioneAzienda.formRefreshInputData('pec', currentOutput['pec']);
            }


            this.userComponentService.destroyCurrentOpenPopUp('NicaInfoAnagraficaAziendaComponent');
            this.userComponentService.destroyOutputComponent();




          }
          if (currentOutput.eventName == 'annullaDatiImpresa' && currentOutput.componentName == 'NicaInfoAnagraficaAziendaComponent') {

            this.userComponentService.destroyCurrentOpenPopUp('NicaInfoAnagraficaAziendaComponent');
            this.userComponentService.destroyOutputComponent();


          }


        });









        //console.log(e);

        //console.log(data);

      }

    }
    if (e == 'confermaAzienda') {

      console.log(this.gestioneAzienda.dataSet);

      let body = {

        descrizione: this.gestioneAzienda.dataSet['descrizione'],
        codiceFiscaleAzienda: this.gestioneAzienda.dataSet['codiceFiscaleAzienda'],
        isAttiva: this.gestioneAzienda.dataSet['isAttiva'],
        indirizzo: this.gestioneAzienda.dataSet['indirizzo'],
        civico: this.gestioneAzienda.dataSet['civico'],
        frazione: this.gestioneAzienda.dataSet['frazione'],
        comune: this.gestioneAzienda.dataSet['comune'],
        cap: this.gestioneAzienda.dataSet['cap'],
        siglaProvincia: this.gestioneAzienda.dataSet['siglaProvincia'],
        istatComune: this.gestioneAzienda.dataSet['istatComune'],
        annoInstallazione: this.gestioneAzienda.dataSet['annoInstallazione'],
        pIvaAzienda: this.gestioneAzienda.dataSet['pIvaAzienda'],
        pec: this.gestioneAzienda.dataSet['pec'],
        logoAzienda: this.logoBase64

      }


      console.log(body);

      if (!this.dati && this.utenteService.DammiTipoUtente() < 3) {

        try {

          let validate = this.gestioneAzienda.validate();

          if (!validate.isValid)
            return;

          await this.http.post(environment.BASE_API_URL.concat('Azienda'), body).toPromise();

          /*
          notify({
            message: 'Dati Azienda modificati con successo!',
            position: {
                my: "center bottom",
                at: "center bottom"
            }
          }, "success", 3000);
          */

          notify({
            message: 'Dati Azienda modificati con successo!',
            height: 45,
            width: 250,
            position: 'center center'
          }, 'success', 3000);



        } catch (errore) {

          /*
          notify({
            message: 'Errore nella modifica/creazione dell`azienda!',
            position: {
                my: "center mid",
                at: "center mid"
            }
          }, "error", 3000);
          */

          return;
        }


        this.onToolbarButtonClick.emit('confermaAzienda');


        return;
      }


      let validate = this.gestioneAzienda.validate();

      if (!validate.isValid)
        return;


      let res = await this.http.put(environment.BASE_API_URL.concat('Azienda/' + (this.utenteService.DammiTipoUtente() == 3 ? this.utenteService.InfoUtenteConnesso.aziendaSelected : (this.dati["id"] as number).toString())), body).toPromise();


      this.gestioneAzienda.dataSet['codiceFiscaleAzienda'] = res['codiceFiscaleAzienda']
      this.gestioneAzienda.dataSet['descrizione'] = res['descrizione']
      this.gestioneAzienda.dataSet['comune'] = res['comune']
      this.gestioneAzienda.dataSet['cap'] = res['cap']
      this.gestioneAzienda.dataSet['indirizzo'] = res['indirizzo']
      this.gestioneAzienda.dataSet['civico'] = res['civico']
      this.gestioneAzienda.dataSet['frazione'] = res['frazione']
      this.gestioneAzienda.dataSet['siglaProvincia'] = res['siglaProvincia']
      this.gestioneAzienda.dataSet['isAttiva'] = res['isAttiva']
      this.gestioneAzienda.dataSet['annoInstallazione'] = res['annoInstallazione'].toString()
      this.gestioneAzienda.dataSet['istatComune'] = res['istatComune']
      this.gestioneAzienda.dataSet['pIvaAzienda'] = res['pIvaAzienda']
      this.gestioneAzienda.dataSet['pec'] = res['pec']

      if (res['pec'])
        this.gestioneAzienda.formRefreshInputData('pec', res['pec']);

      this.logoBase64 = res["logoAzienda"];
      setTimeout(
        () => {
          this.dimensioniOriginali = `Larghezza: ${(document.getElementById('logoAzienda').children.item(0) as HTMLImageElement).naturalWidth}px. - Altezza: ${(document.getElementById('logoAzienda').children.item(0) as HTMLImageElement).naturalHeight}px.`;
        }, 1000
      );

      if (this.utenteService.DammiTipoUtente() == 3) {
        for (let i = 0; i < this.utenteService.InfoUtenteConnesso.aziende.length; i++) {

          if (this.utenteService.InfoUtenteConnesso.aziende[i].id === this.utenteService.InfoUtenteConnesso.aziendaSelected) {

            this.utenteService.InfoUtenteConnesso.aziende[i] = res;
            this.utenteService.InfoDatiUtenteConnesso.aziende[i] = res;
            this.utenteService.SetetUserInfo(this.utenteService.InfoUtenteConnesso);

            break;
          }
        }

      }

      /*
      notify({
        message: 'Dati Azienda modificati con successo',
        position: {
            my: "center bottom",
            at: "center bottom"
        }
      }, "success", 3000);
      */

      notify({
        message: 'Dati Azienda modificati con successo!',
        height: 45,
        width: 250,
        position: 'center center'
      }, 'success', 3000);



      this.onToolbarButtonClick.emit('confermaAzienda');

      let messaggioPerFooter: messagefromComponent = {
        codeMessage: 909,
        descrMessage: 'aggiornaIVAFooter',
        destComponent: 'footer',
        traceMessage: 'aggiornaIVAFooter'
      }

      this.componentService.emitMessage(messaggioPerFooter);

    }
    if (e == "annullaAzienda") {

      this.onToolbarButtonClick.emit('annullaAzienda');



    }



  }

  async onDatiEmessi(evt) {




    if (evt.isBackup) {
      console.log(evt);

      setTimeout(
        () => {

          this.gestioneAzienda.dataSet['codiceFiscaleAzienda'] = evt['codiceFiscaleAzienda']
          this.gestioneAzienda.dataSet['descrizione'] = evt['descrizione']
          this.gestioneAzienda.dataSet['comune'] = evt['comune']
          this.gestioneAzienda.dataSet['cap'] = evt['cap']
          this.gestioneAzienda.dataSet['indirizzo'] = evt['indirizzo']
          this.gestioneAzienda.dataSet['civico'] = evt['civico']
          this.gestioneAzienda.dataSet['frazione'] = evt['frazione']
          this.gestioneAzienda.dataSet['siglaProvincia'] = evt['siglaProvincia']
          this.gestioneAzienda.dataSet['isAttiva'] = evt['isAttiva']
          this.gestioneAzienda.dataSet['annoInstallazione'] = evt['annoInstallazione'].toString()
          this.gestioneAzienda.dataSet['istatComune'] = evt['istatComune']
          this.gestioneAzienda.dataSet['pIvaAzienda'] = evt['pIvaAzienda']
          this.gestioneAzienda.dataSet['pec'] = evt['pec']

          if (!evt['escludiPec']) {
            this.gestioneAzienda.formRefreshInputData('pec', evt['pec']);
          }

        }, 500
      )



      return;
    }



    setTimeout(
      async () => {

        this.gestioneAzienda.formEdit.showValidationSummary = false;

        this.gestioneAzienda.dataSet['codiceFiscaleAzienda'] = evt['vat']
        this.gestioneAzienda.dataSet['pIvaAzienda'] = evt['tax']
        this.gestioneAzienda.dataSet['comune'] = evt['localita']
        this.gestioneAzienda.dataSet['cap'] = evt['cap']
        this.gestioneAzienda.dataSet['indirizzo'] = evt['indirizzo']
        this.gestioneAzienda.dataSet['civico'] = evt['civico']
        this.gestioneAzienda.dataSet['descrizione'] = (evt['ragione_Sociale'] as string).substring(0, 40)

        if (!evt['escludiPec']) {
          this.gestioneAzienda.dataSet['pec'] = evt['pec'];
        }

        //this.gestioneAzienda.formRefreshInputData('siglaProvincia',message.Data.Items['siglaProvincia']);



        let comuni = await this.http.get<any[]>(environment.BASE_API_URL.concat('comune')).toPromise();

        let comuneTrovato = (comuni as any[]).find(
          (comune) => {
            return comune.descrizione.toLowerCase() == evt['localita'].toLowerCase()
          }
        );

        if (!comuneTrovato)
          return;

        //console.log(comuneTrovato);


        this.gestioneAzienda.dataSet['istatComune'] = comuneTrovato.id;
        this.gestioneAzienda.dataSet['siglaProvincia'] = comuneTrovato.siglaProvincia;
      }, 500
    )


  }

  onChiudiPopupInfoAnagrafica(evt: any) {

    //console.log(evt);

  }


  onValueChanged(evt) {

    //console.log(evt);
    if (((evt.value[0] as File).size / 1024 / 1024) > 1) {
      alert('Si prega di inserire un logo le cui dimensioni siano inferiori o uguali a 1 MB', 'Attenzione');
      return;
    }


    let t = this;

    function getBase64(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        //console.log(reader.result);
        t.logoBase64 = (reader.result as string);

        setTimeout(
          () => {
            t.dimensioniOriginali = `Larghezza: ${(document.getElementById('logoAzienda').children.item(0) as HTMLImageElement).naturalWidth}px. - Altezza: ${(document.getElementById('logoAzienda').children.item(0) as HTMLImageElement).naturalHeight}px.`;
          }, 1000
        )
      };
      reader.onerror = function (error) {
        console.error('Error: ', error);
      };
    }

    //var file = document.querySelector('#files > input[type="file"]').files[0];
    getBase64(evt.value[0]); // prints the base64 string
      //alert("wwwwwwwwwwwwwwww","wwwwwwwwwww");
  }



  setGlobalVariable(dati) {

    this.apiset = dati[0].apiset;
    this.id = dati[0].id;
    this.queryString = dati[0].queryString
    this.rowData = dati[0].dati
    this.template = dati[0].template
    this.masterKey = dati[0].masterKey
    this.type = dati[0].tipo
    this.SubjectCall = dati[0].SubjectCall;
    this.InviaA = dati[0].inviaA;
    this.toolbarComponentFilter = dati[0].toolbarComponent

  }

  setGlobalVariableFromParams(routerParam) {

    this.menuService.previousUrl$.subscribe(prevUrl => {

      this.returnUrl = prevUrl
    })


    this.params = routerParam



    console.log('routerParam-->', routerParam)

    this.previusUrl = routerParam.prevUrl

    this.anagraficaDati = this.templateService.getService(routerParam.service);

    if (!this.anagraficaDati) {
      if (routerParam.service) {
        this.SubjectCall = routerParam.service
      }

      return
    }
    /**Setto le Variabili globali dalla conFigurazione dell'anagrafica***/

    const anagraficaFilter = this.anagraficaDati.filter(r => r.configuration);
    this.apiset = anagraficaFilter[0]['configuration']['api'];
    this.SubjectCall = anagraficaFilter[0]['configuration']['service']
    this.type = anagraficaFilter[0]['configuration']['formType'];
    this.nCol = anagraficaFilter[0]['configuration']['nCol'];

    this.allowedAdvancedFilter = anagraficaFilter[0]['configuration']['allowedAdvancedFilter'];
    this.advancedXlsExportFilterTemplateName = anagraficaFilter[0]['configuration']['advancedXlsExportFilterTemplateName'];
    this.isAdvancedXlsExportAvailable = anagraficaFilter[0]['configuration']['isAdvancedXlsExportAvailable'];

    /* Ottengo in nome del servizio legato alla toolbar */
    this.toolbarComponentFilter = anagraficaFilter[0]['configuration']['toolbarSettings'];

    /*
       Ottengo in nome del servizio legato alla Tipo di template dai paramenti,se non è settato utilizzo quello della configurazione 
       presente nell'anagrafica.
     */


    if (routerParam.templateView) {
      this.template = routerParam.templateView;

    } else {
      this.template = this.anagraficaDati[0]['configuration']['template']
    }


    /* Ottengo l'oggetto contente i bottoni della toobar */
    if (typeof this.toolbarComponentFilter != 'undefined') {

      this.serviceButtonsArray = this.anagraficaService.getService(this.toolbarComponentFilter.service);
    }


    /* Setto i filtri globali che arrivano dali paramentri */

    if (routerParam.filter) {
      this.filterID = JSON.parse(routerParam.filter);
    }



    if (routerParam.id) {

      this.id = routerParam.id

    }

    /* 
  
      Se il template è di tipo Griglia o gli dynamicgrid costrusco i paramentri path o qstring per ottenere l'elenco/lista dei dati
      via API 
  
    */


    if (this.template == 'grid' || this.template == 'dynamicGrid') {
      let filterList = anagraficaFilter[0]['configuration']['filterList'];

      if (filterList.includes('&')) {
        let arrayfilterList = filterList.split('&');
        arrayfilterList.forEach(arr => {
          if (arr.includes('$')) {
            const arrayFilterList = arr.split('$');

            arrayFilterList.forEach(keyRif => {
              keyRif = keyRif.includes('?') ? keyRif.replace('?', '') : keyRif;
              if (this.filterID[keyRif]) {
                let data = this.filterID[keyRif];
                filterList = filterList.replace('$' + keyRif, data);
              }
            })

            this.filterGrid = filterList;

          }
        })
      } else {

        let regExp = /\(([^)]+)\)/;
        let matches = regExp.exec(filterList);

        //matches[1] contains the value between the parentheses
        if (matches) {
          if (matches[1].includes('$')) {
            const arrayFilterList = matches[1].split('$');

            //let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']
            arrayFilterList.forEach(keyRif => {
              ////console.log(keyRif)
              if (this.filterID[keyRif]) {
                let data = this.filterID[keyRif];

                try {
                  filterList = filterList.replace('$' + keyRif, data);
                } catch (error) {
                  console.error('ERRORE: ', error)
                  //console.log('FilterID: ', this.filterID)
                }



              }
            })
          }
        } else {
          if (filterList.includes('$')) {
            const arrayFilterList = filterList.split('$');

            //let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']
            arrayFilterList.forEach(keyRif => {
              ////console.log(keyRif)
              if (this.filterID[keyRif]) {
                let data = this.filterID[keyRif];

                try {
                  filterList = filterList.replace('$' + keyRif, data);
                } catch (error) {
                  console.error('ERRORE: ', error)
                  //console.log('FilterID: ', this.filterID)
                }



              }
            })



          }
        }
        this.filterGrid = filterList;

      }





      if (routerParam.queryFilter) {
        if (anagraficaFilter[0]['configuration']['queryFilter']) {
          let arrayQueryFilter = anagraficaFilter[0]['configuration']['queryFilter']

          let newItemQ = ''
          let dataQueryFilter = JSON.parse(routerParam.queryFilter)

          arrayQueryFilter.forEach(idTab => {
            if (typeof dataQueryFilter[idTab['key']] != 'undefined') {
              newItemQ += idTab['key'] + '=' + dataQueryFilter[idTab['key']] + '&';

              //////console.log(idTab['key'] + '=' + dataQueryFilter[idTab['key']])
            }
          });



          if (newItemQ) {
            this.filterGrid = '?' + newItemQ
          }
        }

      }

      /**************************Definizione TItolo Griglia******************************/


      let descEvent = routerParam.descEvent ? routerParam.descEvent : '';
      let keysTitleDaPortare = []
      if (anagraficaFilter[0]['configuration']['campoTitle']) {
        keysTitleDaPortare = anagraficaFilter[0]['configuration']['campoTitle'];
      }

      let titleGriglia = anagraficaFilter[0]['configuration']['titleGriglia']

      keysTitleDaPortare.forEach(keyTitleDaPortare => {
        if (this.filterID[keyTitleDaPortare]) {
          let data = this.filterID[keyTitleDaPortare];;
          let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
          let isMatch = dateType.test(data);

          if (isMatch) {
            let date = new Date(data)
            let month = date.getMonth();
            month = month + 1
            let day = date.getDate().toString().padStart(2, '0');
            data = day + '-' + month + '-' + date.getFullYear()
          }

          if (titleGriglia.includes(keyTitleDaPortare)) {
            titleGriglia = titleGriglia.replace(keyTitleDaPortare, data)
          }

          //titleGriglia = titleGriglia.replace(keyTitleDaPortare, data)
        }
      })

      this.titleDynamic = titleGriglia;

      if (this.template == 'dynamicGrid') {

        this.setVariableDynamicGrid();
        //this.SetToolbarButtons();
      }

      this.filterID['isEdit'] = false

      /*******************************************************/
    } else {

      let filterEditor = anagraficaFilter[0]['configuration']['filterEditor'];

      if (filterEditor.includes('$')) {

        if (this.id != '' && typeof this.id != 'undefined') {
          this.queryString = filterEditor.replace('$', this.id)
        }
      }
    }


    this.masterKey = anagraficaFilter[0]['configuration']['masterKey'];

    if (anagraficaFilter[0]['configuration']['helpDoc']) {

      this.helpDoc = anagraficaFilter[0]['configuration']['helpDoc']


    }


    /*
      Se il template è di tipo form, ottengo i dati 
    */

    if (this.template == 'form' || this.template == 'component') {

      let descEvent = routerParam.descEvent ? routerParam.descEvent : ''
      let keysTitleDaPortare = anagraficaFilter[0]['configuration']['campoTitle'] ? anagraficaFilter[0]['configuration']['campoTitle'] : [];

      let titleDaPortare = '';

      let titleForm = anagraficaFilter[0]['configuration']['titleForm']

      keysTitleDaPortare.forEach(keyTitleDaPortare => {
        if (this.filterID[keyTitleDaPortare]) {
          let data = this.filterID[keyTitleDaPortare];;
          let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
          let isMatch = dateType.test(data);

          if (isMatch) {
            let date = new Date(data)
            let month = date.getMonth();
            month = month + 1
            let day = date.getDate().toString().padStart(2, '0');
            data = day + '-' + month + '-' + date.getFullYear()
          }


          titleForm = titleForm.replace(keyTitleDaPortare, data)
        } else {
          titleForm = titleForm.replace(keyTitleDaPortare, '')
        }
      })

      this.titleDynamic = titleForm;


      if (typeof this.id == 'undefined' || this.id == '') {
        //console.log('SetToolbarButtons', this.serviceButtonsArray)
        //this.SetToolbarButtons()
      }

    }

    if (routerParam.breadcrumb) {
      this.breadcrumbCaption = routerParam.breadcrumb
    } else {
      this.breadcrumbCaption = anagraficaFilter[0]['configuration']['breadcrumbCaption'];
      this.idBreadcrumbGroup = anagraficaFilter[0]['configuration']['idBreadcrumbGroup'];
    }

    //Costrusco i dati costanti da inviare alla form.

    let data
    if (routerParam.filter) {

      data = JSON.parse(routerParam.filter);
      //console.log('routerParamData', data)
      if (anagraficaFilter[0]['configuration']['idTabRif']) {
        let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']

        arrayIdRif.forEach(idTab => {
          if (typeof data[idTab['value']] != 'undefined') {
            this.rowData[idTab['key']] = data[idTab['value']];
          }


        });

      }


    }

    if (routerParam.queryFilter) {

      this.queryFilter = JSON.parse(routerParam.queryFilter);

    }

    let navComponent = sessionStorage.getItem('navComponent')

    if (navComponent) {

      this.cronNavigation = JSON.parse(navComponent);
      this.userComponentService.setNavComponent(this.cronNavigation)

    }

    this.userComponentService.componentRouter.forEach(res => {

      if (Array.isArray(res) && res.length > 0) {
        this.cronNavigation = res.filter(res => res.idTab == routerParam.currentTabId)
      }


    })

    if (this.cronNavigation.length > 0) {
      let navigations = this.cronNavigation.filter(res => res.idTab == this.currentTabId)
      let navigation = navigations[0].data;

      let checkItemIdex = navigation.findIndex(n => n.id == this.idBreadcrumbGroup);


      if (checkItemIdex == -1) {

        let nav = {
          title: this.breadcrumbCaption,
          cRouter: this.router.url.split('?')[0],
          params: this.params,
          idGroup: this.idBreadcrumbGroup,
          idTab: this.currentTabId,
          idData: this.SubjectCall,
          active: true,

        }
        this.userComponentService.setComponentNavigation(nav);
      } else {


        let itemDataNav = {
          title: this.breadcrumbCaption,
          cRouter: this.router.url.split('?')[0],
          params: this.params,
          idGroup: this.idBreadcrumbGroup,
          idTab: this.currentTabId,
          idData: this.SubjectCall,
          active: true,

        }
        this.userComponentService.setNavigationChildren(itemDataNav, this.idBreadcrumbGroup);
      }

    } else {

      let nav = {
        title: this.breadcrumbCaption,
        cRouter: this.router.url.split('?')[0],
        params: this.params,
        idGroup: this.idBreadcrumbGroup,
        idTab: this.currentTabId,
        idData: this.SubjectCall,
        active: true,
        items: []
      }



      this.userComponentService.setComponentNavigation(nav)
    }

    let navigationData = []


    const navigationsFilter = this.cronNavigation.filter(res => res.idTab == this.currentTabId)
    if (navigationsFilter.length > 0) {
      let navigationData = navigationsFilter[0].data;

      this.breadcrumbNavigation = navigationData;

      console.log('breadcrumbNavigation', this.breadcrumbNavigation)
      this.tabNavigationChildrend = navigationData.filter(res => res.idGroup == this.idBreadcrumbGroup)
    }






  }


  setVariableDynamicGrid() {
    //console.log('filterGrid', this.filterGrid);
    //console.log('filterID', this.filterID['idAutorizzazione']);

    this.filterKey = this.filterID['idAutorizzazione'];
    this.campo = {

      type: 'campoComponent',
      labelVisible: false,
      colSpan: "1",
      dataField: 'AutorizzazioneAreaCer',
      validation: [{
        type: 'required',
        message: "My custom message"
      }],
      colVisible: false,
      width: '1700px',

      dynamic: {
        dataSource: 'autorizzazionecer',
        autocomplete: false,
        checkValue: {
          checkValueMessage: '',
          forceInsert: false
        },
        valueExpr: '',
        campoTabRif: 'id', //In edit o in insert sarà sempre l'id che mi verrà restituito dalle API
        displayExpr: 'descrizione',
        caption: "Lista Autorizzazioni EER Zona",
        filter: '',

        componentType: 'dynamicGrid',

        enableEditor: true,
        settingGrid: {
          campoTabRif: 'idAutorizzazione', //è il campo di rif. con il quele effettuare le operazioni di insert, edit e delete della griglia.
          masterKey: 'cer',
          keyUnique: '',
          mode: 'cell',
          remoteOperations: false,
          hoverStateEnabled: true,
          rowAlternationEnabled: true,
          repaintChangesOnly: true,
          allowUpdating: true,
          allowDeleting: true,
          allowAdding: false,
          height: 505,
          showFilterSearch: false,
        }

      }


    }


  }

  /*  
  onUploadError(value) {

    console.error(value.error.response);
    
    //this.popupVisible = false;
    alert(JSON.parse(value.error.response).descrMessage, "Attenzione");
    
    /*this.utenteService.LogOut();
    this.router.navigateByUrl("/");
    console.log(value);
}

onUpload(value) {
    const current = new Date();
    const timestamp = current.getTime();
    //{"codeMessage":0,"descrMessage":"13.png"}
    //console.log("Dopo Upload ",value['descrMessage']);
    //alert(value['descrMessage']);
    let newfoto = JSON.parse(value.request.response)
    console.log("Dopo Upload ", newfoto);
    //this.utenteService.InfoUtenteConnesso.foto = newfoto['descrMessage'];
    //this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso);
    this.logoSrc = environment.BASE_PUBLIC_IMAGE + newfoto['descrMessage'] + "?timestamp=" + timestamp;



    this.dimensioniOriginali = `Larghezza: ${(document.getElementById('logoAzienda') as HTMLImageElement).naturalWidth}px. Altezza: ${(document.getElementById('logoAzienda') as HTMLImageElement).naturalHeight}px.` 
    //alert(this.foto,"Dopo Upload");
    //this.logoSrc = environment.BASE_PUBLIC_IMAGE + newfoto['descrMessage'] + "?timestamp=" + timestamp;
    //this.foto="assets/images/img_avatar2.png";


    //        alert("File Caricato");
}
*/
}

